type PatternResult = string[] | null | undefined
type PatternFun = (error: Error) => PatternResult

/**
 * `{{default}}` is the way that Sentry has to say: "And also include the
 * default fingerprint". In the case we're handling we just add the extra
 * fingerprint to the default one. In all the other cases we just return the
 * default one.
 */
const DEFAULT_FINGERPRINT = ['{{default}}']

export const ERROR_PATTERNS: {
  dataResource: PatternFun
  codeSplit: PatternFun
} = {
  dataResource: (error: Error): PatternResult => {
    const matches = RegExp('Error (finding|getting) (.*) with .*').exec(error.message)

    if (!matches || matches.length < 0) return null

    return [`Invariant: ${matches[2]} must be found`]
  },
  codeSplit: (error: Error): PatternResult => {
    const matches = RegExp('Loading chunk (.*) failed.').exec(error.message)

    if (!matches || matches.length !== 2) return null

    const chunk = matches[1]

    return [`Code split error in chunk: ${chunk}`]
  },
}

function errorFingerprint(error: Error, runPattern: PatternFun): string[] {
  return runPattern(error) || DEFAULT_FINGERPRINT
}

export default errorFingerprint
